import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const LocationNameEleMasterTableDataAPI = createAsyncThunk("LocationNameEleMasterTableData", async ({ data }) => {
    const {
        M_ELEC_LocationID,
        M_UserID,
        token,
        From,
        To,
        M_WardID,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Location_Select?M_ELEC_LocationID=${M_ELEC_LocationID}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const LocationNameEleMasterTableDataSlice = createSlice({
    name: "LocationNameEleMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LocationNameEleMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LocationNameEleMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(LocationNameEleMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const LocationNameEleMasterTableDataReducer = LocationNameEleMasterTableDataSlice.reducer


// InsertUpdate Table Data

export const LocationNameEleMasterPostDataAPI = createAsyncThunk("LocationNameEleMasterPostData", async ({ data }) => {
    const {
        M_ELEC_LocationID,
        M_WardID,
        LocationName,
        M_UserID,
        token,
        Flag,
        setLoading,
        handleIsPost,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (Flag == "Update") {
        formdata.append("M_ELEC_LocationID", M_ELEC_LocationID);
    }
    formdata.append("M_WardID", M_WardID);
    formdata.append("LocationName", LocationName);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: Flag == "Update" ? 'PATCH' : 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)
    let url
    if (Flag == "Update") {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_Location_Update`
    } else {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_Location_Insert`
    }
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                toastSuccesss(result.message)
                handleOnCloseClick()
                setLoading(false)
                return result.data
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const LocationNameEleMasterPostDataSlice = createSlice({
    name: "LocationNameEleMasterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LocationNameEleMasterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LocationNameEleMasterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(LocationNameEleMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const LocationNameEleMasterPostDataReducer = LocationNameEleMasterPostDataSlice.reducer



// Delete Table Data

export const LocationNameELEMasterDeleteAPI = createAsyncThunk("LocationNameELEMasterDelete", async ({ data }) => {
    const {
        M_ELEC_LocationID,
        M_UserID,
        handleIsPost,
        token,
        handleDeleteCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ELEC_LocationID", M_ELEC_LocationID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Post_M_ELEC_Location_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
                handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                handleDeleteCloseClick()
            }
            return result

        })
})

const LocationNameELEMasterDeleteSlice = createSlice({
    name: "LocationNameELEMasterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LocationNameELEMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(LocationNameELEMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;

        });
        builder.addCase(LocationNameELEMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const LocationNameELEMasterDeleteReducer = LocationNameELEMasterDeleteSlice.reducer